/**
 * SxaFooterTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import iNexusLogo from './images/inexus_logo_white.svg';
import LinkedInIcon from './images/inx_linkedin.svg';
import FacebookIcon from './images/inx_facebook.svg';
import TwitterIcon from './images/inx_twitter.svg';
import YouTubeIcon from './images/inx_youtube.svg';
import CircleMinus from './images/circleMinus.png';
import CirclePlus from './images/circlePlus.png';

import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    appBar: {
        top: 'auto',
        bottom: 0,
    },
    toolbar: {
        alignItems: 'center',
        justifyContent: 'space-between',
    },
});

class SxaFooterTile extends React.Component {
    constructor(props) {
        super(props);

        // Assign A ref to state for refresh
        this.state = { ass: props.ass,
            expanded: false
        };

        this.toggleExpanded = this.toggleExpanded.bind(this);
    }

    toggleExpanded = () => {
        console.log("Footer expanded flag toggle");
        var newExpanded = !this.state.expanded;
        this.setState( { expanded: newExpanded } );
    }

    render() {
        const { classes } = this.props;
        return(
            <React.Fragment>
            <CssBaseline/>
                <AppBar position="fixed" color="primary" className={classes.appBar}
                        style={{ backgroundColor: '#1e2b56',
                                maxHeight: (this.state.expanded ? 300: 56) }}>
                    <Toolbar>
                        <Grid container spacing={0} direction="row" justify="space-evenly" alignItems="stretch">
                            <Grid item xs={12} sm={12} lg={12} xl={12}>
                                <Grid container spacing={0} direction="row" justify="space-evenly" alignItems="stretch">
                                    <Grid item xs={5} sm={5} lg={5} xl={5} align="left">
                                        <Grid container spacing={0} direction="row" justify="space-evenly" alignItems="stretch">
                                            <Grid item xs={6} sm={6} lg={6} xl={6} align="left">
                                                <Grid container spacing={0} direction="row" justify="flex-start" alignItems="center">
                                                    <Grid item>
                                                        <Typography variant="inherit" color="inherit"
                                                                    onClick={this.toggleExpanded}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        fontSize: 14,
                                                                        paddingTop: (this.state.expanded ? 8: 0),
                                                                        fontFamily: 'Open Sans, sans-serif',
                                                                        minWidth: 76,
                                                                        maxWidth: 76
                                                                    }}>
                                                            Contact us
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        {this.state.expanded ?
                                                            <img src={CircleMinus} onClick={this.toggleExpanded} alt="Plus" height="14px"
                                                                 style={{cursor: 'pointer', marginTop: (this.state.expanded ? 12: 3)}}/>
                                                            :
                                                            <img src={CirclePlus} onClick={this.toggleExpanded} alt="Plus" height="14px"
                                                                 style={{cursor: 'pointer', marginTop: (this.state.expanded ? 12: 3)}}/>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={6} sm={6} lg={6} xl={6}>
                                                <a href="https://www.i-nexus.com/company" target="_blank" rel="noopener noreferrer"
                                                   style={{color: "#608AD8", textDecoration: 'none'}}>
                                                    <Typography variant="inherit" color="inherit" align="left"
                                                                style={{
                                                                    fontSize: 14,
                                                                    paddingTop: (this.state.expanded ? 10: 0),
                                                                    fontFamily: 'Open Sans, sans-serif'
                                                                }}>
                                                        About StratexAssess
                                                    </Typography>
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2} lg={2} xl={2}>
                                        <Grid container spacing={0} direction="row" justify="center" alignItems="center"
                                              style={{marginTop: (this.state.expanded ? 10: 0)}}>
                                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                            </Grid>
                                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                <a href="https://www.linkedin.com/company/i-nexus" target="_blank"
                                                   rel="noopener noreferrer">
                                                    <img src={LinkedInIcon} alt="Twitter" align="center" height="20px"/>
                                                </a>
                                            </Grid>
                                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                <a href="https://www.youtube.com/channel/UC8_S43QeT_b5PusmTiig-uw"
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    <img src={YouTubeIcon} alt="Twitter" align="center" height="20px"/>
                                                </a>
                                            </Grid>
                                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                                <a href="https://twitter.com/inexus_software" target="_blank"
                                                   rel="noopener noreferrer">
                                                    <img src={TwitterIcon} alt="Twitter" align="center" height="20px"/>
                                                </a>
                                            </Grid>
                                            <Grid item xs={2} sm={2} lg={2} xl={2}>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={5} sm={5} lg={5} xl={5} align="right">
                                        <Grid container spacing={0} direction="row" justify="flex-end" alignItems="center">
                                            <Grid item >
                                                <a href="https://www.i-nexus.com/terms-of-use" target="_blank"
                                                   rel="noopener noreferrer" style={{ color: "#6e8cc4", textDecoration: 'none' }}>
                                                    <Typography variant="inherit" color="inherit" align="left"
                                                                style={{
                                                                    fontSize: 14, paddingTop: (this.state.expanded ? 10: 0),
                                                                    color: "#6e8cc4",
                                                                    fontFamily: 'Open Sans, sans-serif'
                                                                }}>
                                                        Legal
                                                    </Typography>
                                                </a>
                                            </Grid>
                                            <Grid item >
                                                <a href="https://www.i-nexus.com/privacy-policy" target="_blank"
                                                   rel="noopener noreferrer" style={{ color: "#6e8cc4", textDecoration: 'none' }}>
                                                    <Typography variant="inherit" color="inherit" align="left"
                                                                style={{
                                                                    fontSize: 14, paddingTop: (this.state.expanded ? 10: 0),
                                                                    color: "#6e8cc4",
                                                                    paddingLeft: 20,
                                                                    fontFamily: 'Open Sans, sans-serif'
                                                                }}>
                                                        Privacy
                                                    </Typography>
                                                </a>
                                            </Grid>
                                            <Grid item >
                                                <a href="https://www.i-nexus.com/cookie-policy" target="_blank"
                                                   rel="noopener noreferrer" style={{ color: "#6e8cc4", textDecoration: 'none' }}>
                                                    <Typography variant="inherit" color="inherit" align="left"
                                                                style={{
                                                                    fontSize: 14, paddingTop: (this.state.expanded ? 10: 0),
                                                                    paddingLeft: 14,
                                                                    color: "#6e8cc4",
                                                                    fontFamily: 'Open Sans, sans-serif'
                                                                }}>
                                                        Cookies
                                                    </Typography>
                                                </a>
                                            </Grid>
                                            <Grid item style={{ marginLeft: 20 }}>
                                                <Typography variant="inherit" color="inherit" align="right"
                                                            style={{
                                                                fontSize: 14,
                                                                fontFamily: 'Open Sans, sans-serif',
                                                                paddingTop: (this.state.expanded ? 10: 0),
                                                                paddingRight: '1.0em',
                                                                color: "#6e8cc4"
                                                            }}>
                                                    Copyright © 2019 i-nexus Global plc
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {this.state.expanded ?
                                <Grid item xs={12} sm={12} lg={12} xl={12} style={{marginTop: '0.5em', marginBottom: '0.5em'}}>
                                    <Grid container spacing={0} direction="row" justify="space-evenly" alignItems="stretch">
                                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                UK HEADQUARTERS
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingTop: '0', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                i-nexus Suite, George House, Herald Avenue,
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingTop: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                Coventry Business Park, Coventry, CV5 6UB
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                SALES & GENERAL ENQUIRIES
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingTop: '0.25em', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                UK: +44 (0)845 607 0061
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingTop: '0', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                USA: +1 855 615 1589
                                            </Typography>
                                            <a href="mailto:info@i-nexus.com" target="_blank" rel="noopener noreferrer"
                                               style={{color: "#608AD8", textDecoration: 'none'}}>
                                                <Typography variant="title" color="inherit" align="left"
                                                            style={{
                                                                fontSize: '0.7em',
                                                                padding: '1.0em', paddingTop: '0', paddingLeft: '0',
                                                                color: "white",
                                                                fontFamily: 'Open Sans, sans-serif'
                                                            }}>
                                                    info@i-nexus.com
                                                </Typography>
                                            </a>
                                        </Grid>
                                        <Grid item xs={6} sm={6} lg={6} xl={6}>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontWeight: 'bold', fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                SUPPORT
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingTop: '0.25em', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                UK: +44 (0)845 607 0062
                                            </Typography>
                                            <Typography variant="title" color="inherit" align="left"
                                                        style={{
                                                            fontSize: '0.7em',
                                                            padding: '1.0em', paddingTop: '0', paddingBottom: '0', paddingLeft: '0',
                                                            color: "white",
                                                            fontFamily: 'Open Sans, sans-serif'
                                                        }}>
                                                USA: +1 877 301 0769
                                            </Typography>
                                            <a href="mailto:support@i-nexus.com" target="_blank" rel="noopener noreferrer"
                                               style={{color: "#608AD8", textDecoration: 'none'}}>
                                                <Typography variant="title" color="inherit" align="left"
                                                            style={{
                                                                fontSize: '0.7em',
                                                                padding: '1.0em', paddingTop: '0', paddingLeft: '0',
                                                                color: "white",
                                                                fontFamily: 'Open Sans, sans-serif'
                                                            }}>
                                                    support@i-nexus.com
                                                </Typography>
                                            </a>
                                        </Grid>
                                        <Grid item xs={6} sm={6} lg={6} xl={6}>
                                            <Grid container spacing={0} direction="row" justify="flex-start" alignItems="stretch">
                                                <Grid item xs={8} sm={8} lg={8} xl={8}>
                                                    <Typography variant="title" color="inherit" align="right"
                                                        style={{
                                                        fontSize: '0.7em', paddingTop: '0.5em', color: "#7882A6",
                                                        fontFamily: 'Open Sans, sans-serif', marginTop: '1.5em'
                                                    }}>
                                                    i-nexus is the trading name of i-nexus Global plc registered in England & Wales,
                                                    registration number 11321642, VAT registration number GB 300 149 263.
                                                    All rights reserved. Various trademarks held by their respective owners
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} sm={4} lg={4} xl={4}>
                                                    <img src={iNexusLogo} alt="Logo" align="right" height="48"
                                                        style={{marginRight: '0.5em', marginTop: '1.5em'}}/>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                :
                                ""
                            }
                        </Grid>
                    </Toolbar>
                </AppBar>
            </React.Fragment>
        )
    }
}

/* FB icon removed Nov-2019
<Grid item xs={2} sm={2} lg={2} xl={2}>
    <a href="https://www.facebook.com/inexussoftware/" target="_blank"
       rel="noopener noreferrer">
        <img src={FacebookIcon} alt="Twitter" align="center" height="20px"/>
    </a>
</Grid>
*/

SxaFooterTile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SxaFooterTile);